import { ROUTE_META_PARAMS } from '@/router/consts.js'

const defaultMeta = Object.freeze({
  [ROUTE_META_PARAMS.HIDDEN_IN_SEARCH]: false,
  [ROUTE_META_PARAMS.HIDDEN_IN_PRODUCTION]: false,
  [ROUTE_META_PARAMS.FEATURE_FLAG]: false,
  [ROUTE_META_PARAMS.ACCESS_LEVEL]: false,
  [ROUTE_META_PARAMS.SHOULD_BE_VISIBLE]: true,
  [ROUTE_META_PARAMS.DARK]: false,
  [ROUTE_META_PARAMS.RIGHT_ICON]: '',
  [ROUTE_META_PARAMS.STATUS_GETTER]: false,
  [ROUTE_META_PARAMS.ON_TILE_CLICK]: false,
  [ROUTE_META_PARAMS.NO_INDEX_VIEW]: false,
  [ROUTE_META_PARAMS.SEARCH_IS_VISIBLE]: false,
  [ROUTE_META_PARAMS.SEARCH_PLACEHOLDER]: false,
  [ROUTE_META_PARAMS.IS_TILES_VIEW]: false,
  useSmartlook: false,
  defaultSubroute: undefined,
  hideSidebar: false,
  hintKey: undefined,
  hideTabs: false,
  fullContent: false,
})
export const setMeta = (routes) => {
  routes.forEach(route => {
    route.meta = { ...defaultMeta, ...(route.meta || {}) }

    if (route.children) {
      setMeta(route.children)
    }
  })
}
